import ShowRegisterContainer from './ShowRegisterContainer';

export default ShowRegisterContainer;
